export const groupdata = (table1, table2, key, label) => {
    table1.forEach(row1 => {
        table2.forEach(row2 => {
            if (row1.id === row2[key]) {
                // console.log(row1.id + " " + row1.sector + " " + row2.sector);
                row2[label] = row1[key]
            }
        }
        )
    });
    return table2
}
